import axios from "axios";
import { awsUrl, newApiBaseUrl } from "../../axiosInstance";
import * as actionType from "../store/action";

export const getFiltersWithItems = (kind) => {
  if (!kind || String(kind).trim() === "" || String(kind) === "undefined") {
    return Promise.reject(new Error("getFiltersWithItems: missing kind"));
  }
  return axios.get(`${newApiBaseUrl}/dict/${kind}`, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const editItem = (kind, Id, item) => {
  return axios.patch(`${newApiBaseUrl}/dict/${kind}/${Id}`, item, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};
export const editItemPosition = (kind, id, position) => {
  console.log(kind, "kind");
  console.log(id, "id");
  console.log(position, "position");
  kind = kind.split("-").pop();

  return axios.patch(
    `${newApiBaseUrl}/dict/${kind}/position/${id}`,
    { position },
    {
      headers: {
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

export const deleteItemInFilter = (data, kind) => {
  const id = data.id;
  console.log(kind, id, "deleteItemInFilter");

  return axios.delete(`${newApiBaseUrl}/dict/${kind}/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const createItemInFilter = (kind, item) => {
  console.log(kind, item, "createItemInFilter");
  const kindy = kind.replace("hamazon-", "");
  return axios.post(`${newApiBaseUrl}/dict/${kindy}`, item, {
    headers: {
      Authorization: `Bearer ${localStorage.jwtToken}`,
      "X-Tenant": "hamazon",
      "Content-Type": "application/json",
    },
  });
};

export const getPresignedUrl = (file, folder) => {
  return axios.post(
    `${newApiBaseUrl}/create-s3-presigned`,
    {
      fileName: file.name,
      fileType: file.type,
      size: file.size,
      folder: folder,
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.jwtToken}`,
        "X-Tenant": "hamazon",
        "Content-Type": "application/json",
      },
    },
  );
};

//not in use now
export const getFilters = (kind) => {
  return (dispatch) => {
    if (!kind || String(kind).trim() === "" || String(kind) === "undefined") {
      if (process.env.NODE_ENV !== "production") {
        console.warn("getFilters skipped: missing kind", { kind });
      }
      return;
    }
    axios
      .get(`${newApiBaseUrl}/dict/${kind}`, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
          "X-Tenant": "hamazon",
          "Content-Type": "application/json",
        },
      })
      .then((x) => {
        console.log(x.data, "x");

        dispatch({
          type: actionType.SET_FILTER,
          payload: {
            kind,
            items: x.data,
          },
        });
      })
      .catch((err) => {
        console.error("שגיאה בטעינת פילטרים:", err);
      });
  };
};

export const ParameterName = (parameterName) => {
  return (dispatch) =>
    axios
      .get(`${awsUrl}/v1/parameters/${parameterName}`, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) =>
        dispatch({
          type: actionType.SET_PARAMETER,
          key: parameterName,
          data: x.data,
        }),
      );
};

export const editParameter = (data) => {
  return (dispatch) => {
    axios
      .put(`${awsUrl}/v1/parameters`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch(editFilter(x.data));
      });
  };
};
export const addParameter = (data) => {
  return (dispatch) => {
    axios
      .post(`${awsUrl}/v1/parameters`, data, {
        headers: {
          Authorization: `bearer ${localStorage.jwtToken}`,
        },
      })
      .then((x) => {
        dispatch(addFilter(x.data));
      });
  };
};
export const addFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: actionType.ADD_FILTER, payload: filter });
  };
};
export const editFilter = (filter) => {
  return (dispatch) => {
    dispatch({ type: actionType.EDIT_FILTER, payload: filter });
  };
};
